// extracted by mini-css-extract-plugin
export var container = "_5h-0";
export var infoButton = "_5h-1";
export var label = "_5h-3";
export var labelExpanded = "_5h-4";
export var price = "_5h-5";
export var priceExpanded = "_5h-6";
export var title = "_5h-2";